"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hardcodedVolumeInfo = void 0;
/** コンメンタールで条に対応するTOC項目のdepth */
const KOMMENTAR_ARTICLE_DEPTH = 5;
exports.hardcodedVolumeInfo = {
    // 会社法コンメンタール
    kommentar_shojihomu_kaishaho_1: {
        volumeNumber: '1',
        volumeNumberSuffix: '巻',
        volumeTitle: '総則・設立 ⑴',
        rangeDescription: '1〜31条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_2: {
        volumeNumber: '2',
        volumeNumberSuffix: '巻',
        volumeTitle: '設立 ⑵',
        rangeDescription: '32〜103条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_3: {
        volumeNumber: '3',
        volumeNumberSuffix: '巻',
        volumeTitle: '株式 ⑴',
        rangeDescription: '104〜154の2条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_4: {
        volumeNumber: '4',
        volumeNumberSuffix: '巻',
        volumeTitle: '株式 ⑵',
        rangeDescription: '155〜198条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_5: {
        volumeNumber: '5',
        volumeNumberSuffix: '巻',
        volumeTitle: '株式 ⑶',
        rangeDescription: '199〜235条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_6: {
        volumeNumber: '6',
        volumeNumberSuffix: '巻',
        volumeTitle: '新株予約権',
        rangeDescription: '236〜294条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_7: {
        volumeNumber: '7',
        volumeNumberSuffix: '巻',
        volumeTitle: '機関 ⑴',
        rangeDescription: '295〜347条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_8: {
        volumeNumber: '8',
        volumeNumberSuffix: '巻',
        volumeTitle: '機関 ⑵',
        rangeDescription: '348〜395条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_9: {
        volumeNumber: '9',
        volumeNumberSuffix: '巻',
        volumeTitle: '機関 ⑶',
        rangeDescription: '396〜430条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_10: {
        volumeNumber: '10',
        volumeNumberSuffix: '巻',
        volumeTitle: '計算等 ⑴',
        rangeDescription: '431〜444条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_11: {
        volumeNumber: '11',
        volumeNumberSuffix: '巻',
        volumeTitle: '計算等 ⑵',
        rangeDescription: '445〜465条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_12: {
        volumeNumber: '12',
        volumeNumberSuffix: '巻',
        rangeDescription: '466〜509条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_13: {
        volumeNumber: '13',
        volumeNumberSuffix: '巻',
        volumeTitle: '清算 ⑵',
        rangeDescription: '510〜574条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_14: {
        volumeNumber: '14',
        volumeNumberSuffix: '巻',
        volumeTitle: '持分会社 ⑴',
        rangeDescription: '575〜613条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_15: {
        volumeNumber: '15',
        volumeNumberSuffix: '巻',
        volumeTitle: '持分会社 ⑵',
        rangeDescription: '614〜675条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_16: {
        volumeNumber: '16',
        volumeNumberSuffix: '巻',
        volumeTitle: '社債',
        rangeDescription: '676〜742条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_17: {
        volumeNumber: '17',
        volumeNumberSuffix: '巻',
        rangeDescription: '743〜774条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_18: {
        volumeNumber: '18',
        volumeNumberSuffix: '巻',
        rangeDescription: '775〜816条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_19: {
        volumeNumber: '19',
        volumeNumberSuffix: '巻',
        volumeTitle: '外国会社・雑則 ⑴',
        rangeDescription: '817〜867条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_20: {
        volumeNumber: '20',
        volumeNumberSuffix: '巻',
        volumeTitle: '雑則 ⑵',
        rangeDescription: '868〜938条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_21: {
        volumeNumber: '21',
        volumeNumberSuffix: '巻',
        volumeTitle: '雑則 ⑶・罰則',
        rangeDescription: '939〜979条',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    kommentar_shojihomu_kaishaho_sup: {
        volumeNumber: '補巻',
        volumeTitle: '平成26年改正',
        targetDepth: KOMMENTAR_ARTICLE_DEPTH,
    },
    // 新注釈民法
    9784641017542: {
        volumeNumber: '1',
        volumeNumberSuffix: '巻',
        volumeTitle: '総則 ⑴',
        rangeDescription: '1〜89条',
        targetDepth: 3,
    },
    9784641017597: {
        volumeNumber: '5',
        volumeNumberSuffix: '巻',
        volumeTitle: '物権 ⑵',
        rangeDescription: '180〜294条',
        targetDepth: 4,
    },
    9784641017559: {
        volumeNumber: '6',
        volumeNumberSuffix: '巻',
        volumeTitle: '物権 ⑶',
        rangeDescription: '295〜372条',
        targetDepth: 4,
    },
    9784641017573: {
        volumeNumber: '7',
        volumeNumberSuffix: '巻',
        volumeTitle: '物権 ⑷',
        rangeDescription: '373〜398条22',
        targetDepth: 3,
    },
    9784641017689: {
        volumeNumber: '8',
        volumeNumberSuffix: '巻',
        volumeTitle: '債権 ⑴',
        rangeDescription: '399〜422条2',
        targetDepth: 4,
    },
    9784641017726: {
        volumeNumber: '11',
        volumeNumberSuffix: '巻Ⅱ',
        volumeTitle: '債権 ⑷',
        rangeDescription: '533〜548条4',
        targetDepth: 4,
    },
    9784641017702: {
        volumeNumber: '13',
        volumeNumberSuffix: '巻Ⅰ',
        volumeTitle: '債権 ⑹',
        rangeDescription: '587〜622条2',
        targetDepth: 4,
    },
    9784641017603: {
        volumeNumber: '14',
        volumeNumberSuffix: '巻',
        volumeTitle: '債権 ⑺',
        rangeDescription: '623〜696条',
        targetDepth: 3,
    },
    9784641017511: {
        volumeNumber: '15',
        volumeNumberSuffix: '巻',
        volumeTitle: '債権 ⑻',
        rangeDescription: '697〜711条',
        targetDepth: 2,
    },
    9784641017566: {
        volumeNumber: '16',
        volumeNumberSuffix: '巻',
        volumeTitle: '債権 ⑼',
        rangeDescription: '712〜724条2',
        targetDepth: 2,
    },
    9784641017528: {
        volumeNumber: '17',
        volumeNumberSuffix: '巻',
        volumeTitle: '親族 ⑴',
        rangeDescription: '725〜791条',
        targetDepth: 2,
    },
    9784641017580: {
        volumeNumber: '19',
        volumeNumberSuffix: '巻初版',
        volumeTitle: '相続 ⑴',
        rangeDescription: '882〜959条',
        targetDepth: 4,
    },
    9784641017719: {
        volumeNumber: '19',
        volumeNumberSuffix: '巻第2版',
        volumeTitle: '相続 ⑴',
        rangeDescription: '882〜959条',
        targetDepth: 4,
    },
};
